export default "__VITE_ASSET__db849e2e__"